import React from 'react';
import { UHC } from '../../../types';
import sortDisclaimersByCategory, { getFooterDisclaimers } from '../../../utils/disclaimers';

interface SearchDisclaimersProps {
  disclaimers: UHC.Disclaimer[] | undefined;
}

const SearchDisclaimers: React.FC<SearchDisclaimersProps> = ({ disclaimers }) => {
  // The Premium Disclaimer renders inside the "What is UnitedHealth Premium Care
  // Physician?" modal, so it is excluded from this footer list (see getFooterDisclaimers).
  const disclaimersByCategory = sortDisclaimersByCategory(getFooterDisclaimers(disclaimers));

  const disclaimerElements = Object.keys(disclaimersByCategory).flatMap((categoryName) => {
    const disclaimerMessages = disclaimersByCategory[categoryName].map((message) => (
      <li key={message}>
        <div className="search-disclaimers__message">{message}</div>
      </li>
    ));

    return (
      <div className="search-disclaimers__category" key={categoryName}>
        <div className="search-disclaimers__category-name">{categoryName}</div>
        <ul className="search-disclaimers__message-list">{disclaimerMessages}</ul>
      </div>
    );
  });

  return <div className="search-disclaimers">{disclaimerElements}</div>;
};

export default SearchDisclaimers;
